import { render, staticRenderFns } from "./AddHospitalRecruiters.vue?vue&type=template&id=192e622d&scoped=true"
import script from "./AddHospitalRecruiters.vue?vue&type=script&lang=js"
export * from "./AddHospitalRecruiters.vue?vue&type=script&lang=js"
import style0 from "./AddHospitalRecruiters.vue?vue&type=style&index=0&id=192e622d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192e622d",
  null
  
)

export default component.exports